import Vue from 'vue'
import {
  AllPagesMessage,
  CurrentPageMessage,
  DoneRenderingPdfMessage,
  GrabbingDoneMessage,
  GrabbingStoppedMessage, PagesInBetweenMessage,
  PdfRotationMessage,
  StartEntirePageGrabMessage
} from './constants/pdf-messages'
export const EventBus = new Vue();

window.addEventListener('message', function (e) {
  switch (e.data.message) {
    case GrabbingDoneMessage:
      EventBus.$emit(GrabbingDoneMessage, e);
      break;
    case GrabbingStoppedMessage:
      EventBus.$emit(GrabbingStoppedMessage, e);
      break;
    case 'refreshMessage':
      EventBus.$emit('refreshMessage', e);
      break;
    case StartEntirePageGrabMessage:
      EventBus.$emit(StartEntirePageGrabMessage);
      break;
    case PdfRotationMessage:
      EventBus.$emit(PdfRotationMessage, e);
      break;
    case DoneRenderingPdfMessage:
      EventBus.$emit(DoneRenderingPdfMessage);
      break;
    case CurrentPageMessage:
      EventBus.$emit(CurrentPageMessage, e);
      break;
    case PagesInBetweenMessage:
      EventBus.$emit(PagesInBetweenMessage, e);
      break;
    case AllPagesMessage:
      EventBus.$emit(AllPagesMessage, e);
      break;
  }
});
